import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar, DropdownButton, MenuItem} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, integerField} from '../../core/redux/form'
import extract from '../../core/extract'
import config from '../../config'
import {DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_UPDATED, sendDefineServiceChargeForInterventionPeriodCmd, updateDefineServiceChargeForInterventionPeriodCmd, sendRemoveServiceChargeFromInterventionPeriodCmd, loadProvider} from '../actions'
import {CHARGE_TYPES, DefineServiceChargeForInterventionPeriodCmd} from '../models'
import i18n from '../i18n'

function defineCmdUpdate(interventionPeriod) {
    return {
        charge: interventionPeriod.serviceCharge || {chargeType: CHARGE_TYPES[0]}
    }
}

class DefineRemoveServiceChargeFromInterventionPeriodForm extends Component {
    static propTypes = {
        activity: PropTypes.object.isRequired,
        interventionPeriod: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {dispatch, interventionPeriod} = this.props

        const update = defineCmdUpdate(interventionPeriod)
        dispatch(updateDefineServiceChargeForInterventionPeriodCmd(update))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.interventionPeriod != this.props.interventionPeriod) {
            const {dispatch, interventionPeriod} = nextProps

            const update = defineCmdUpdate(interventionPeriod)
            dispatch(updateDefineServiceChargeForInterventionPeriodCmd(update))
        }
    }

    _sendDefineCmd() {
        const {dispatch, activity, interventionPeriod, onSubmit} = this.props

        return dispatch(sendDefineServiceChargeForInterventionPeriodCmd(activity.uid, interventionPeriod.uid)).then(() => {
            return dispatch(loadProvider())
        }).then(() => {
            onSubmit()
        })
    }

    _sendRemoveCmd() {
        const {dispatch, activity, interventionPeriod, onSubmit} = this.props

        return dispatch(sendRemoveServiceChargeFromInterventionPeriodCmd(activity.uid, interventionPeriod.uid)).then(() => {
            return dispatch(loadProvider())
        }).then(() => {
            onSubmit()
        })
    }

    render() {
        const {dispatch, form, cmd, activity, interventionPeriod, ...others} = this.props

        const chargeTypeField = (field) => {
            const title = extract(i18n.chargeTypeEnum, field.value && field.value.chargeType)

            function onSelect(event, chargeType) {
                field.onChange({value: null, chargeType})
            }

            return {title, onSelect}
        }

        const valueField = (field, chargeType) => {
            var value

            switch(chargeType) {
                case 'FixChargeValue':
                    value = field.value
                    break
                case 'ChargePercentage':
                    value = field.value && Math.round(field.value * 100)
                    break
            }

            function onChange(valuez) {
                var value

                switch(chargeType) {
                    case 'FixChargeValue':
                        value = valuez
                        break
                    case 'ChargePercentage':
                        value = valuez && valuez / 100
                        break
                }
                field.onChange(value)
            }

            return {...field, value, onChange}
        }

        const chargeInputButton = (
            <DropdownButton
                {...chargeTypeField(form.charge())}>
                {CHARGE_TYPES.map((chargeType) => (
                    <MenuItem eventKey={chargeType}>{extract(i18n.chargeTypeEnum, chargeType)}</MenuItem>
                ))}
            </DropdownButton>
        )

        return (
            <div>
                <form>
                    <Input
                        type='text'
                        name='charge'
                        placeholder={i18n.charge}
                        buttonAfter={chargeInputButton}
                        {...integerField(valueField(form.charge.value(), cmd && cmd.charge && cmd.charge.chargeType))} />
                </form>
                <ButtonToolbar>
                    <Button
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid()})}
                        onClick={() => form.validate() && this._sendDefineCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.validate}
                    </Button>
                    {interventionPeriod.serviceCharge && (
                        <Button
                            bsStyle='danger'
                            bsSize='large'
                            onClick={() => this._sendRemoveCmd()}>
                            {i18n.remove}
                        </Button>
                    )}
                </ButtonToolbar>
            </div>
        )
    }
}

DefineRemoveServiceChargeFromInterventionPeriodForm = connectForm({
    target: 'cmd',
    schema: DefineServiceChargeForInterventionPeriodCmd.schema,
    action: DEFINE_SERVICE_CHARGE_FOR_INTERVENTION_PERIOD_CMD_UPDATED
})(DefineRemoveServiceChargeFromInterventionPeriodForm)

DefineRemoveServiceChargeFromInterventionPeriodForm = connect((state) => ({
    cmd: state.provider.defineServiceChargeForInterventionPeriodCmd,
}))(DefineRemoveServiceChargeFromInterventionPeriodForm)

export default DefineRemoveServiceChargeFromInterventionPeriodForm


// WEBPACK FOOTER //
// ./lib/provider/components/DefineRemoveServiceChargeFromInterventionPeriodForm.js